export default {
  brand: "USFansLink",
  nav_spreadsheet: "Hoja de cálculo",
  nav_guides: "Guías",
  nav_reviews: "Reseñas",
  nav_shipping: "Envío",
  nav_coupon: "Cupones",
  nav_warehouse: "Almacén",
  nav_safety: "Seguridad",
  nav_faq: "Preguntas",
  nav_home: "Inicio",
  nav_shopping_guide: "Guía de compras",
  explore_main: "Explorar sitio principal",
  back_home: "Volver al inicio",
  read_more: "Leer más",
  visit_main: "Visitar sitio principal",
  independent_note: "Recurso informativo independiente · Sin afiliación oficial con USFans",
  language_label: "Idioma",
  cat_shoes: "Zapatos",
  cat_hoodies: "Sudaderas",
  cat_tshirts: "Camisetas",
  cat_jackets: "Chaquetas",
  cat_pants: "Pantalones / Shorts",
  cat_headwear: "Gorros y gorras",
  cat_sets: "Conjuntos",
  cat_underwear: "Ropa interior",
  cat_jersey: "Camisetas deportivas",
  cat_accessories: "Accesorios",
  cat_bags: "Bolsos",
  cat_belts: "Cinturones",
  cat_perfumes: "Perfumes",
  cat_other: "Otras cosas",
  footer_resources: "Recursos",
  footer_company: "Empresa",
  footer_links: "Enlaces rápidos",
  footer_about: "Acerca de",
  footer_contact: "Contacto",
  footer_editorial: "Política editorial",
  footer_updates: "Actualizaciones",
  footer_disclaimer: "Aviso legal",
  footer_privacy: "Política de privacidad",
  footer_terms: "Términos",
  footer_rights: "Todos los derechos reservados.",
  footer_tagline: "Un centro independiente de recursos, guías e información de seguridad sobre la hoja de cálculo de USFans.",
};